import { CreateAndChargeNewOrgCardInput, QuoteInput, SelfServeHelpInput } from 'globalTypes';
import CREATE_AND_CHARGE_NEW_ORG_CARD_MUTATION from 'admin/mutations/CreateAndChargeNewOrgCard.gql';
import CREATE_SELF_SERVE_HELP_REQUEST_MUTATION from 'admin/mutations/CreateSelfServeHelpRequest.gql';
import RemindAPI from 'lib/RemindAPI';
import ToastActions from 'actions/ToastActions';

import {
  CreateAndChargeNewOrgCard,
  CreateAndChargeNewOrgCardVariables,
} from 'admin/mutations/__generated__/CreateAndChargeNewOrgCard';

import {
  SelfServeRequestHelpMutation,
  SelfServeRequestHelpMutationVariables,
} from 'admin/mutations/__generated__/SelfServeRequestHelpMutation';

export function createSelfServeHelpRequest(input: SelfServeHelpInput) {
  return RemindAPI.execute<SelfServeRequestHelpMutation, SelfServeRequestHelpMutationVariables>({
    mutation: CREATE_SELF_SERVE_HELP_REQUEST_MUTATION,
    variables: { input },
  });
}

export function convertSelfServeLead(
  sourceId: string,
  organizationUuid: string,
  organizationId: number,
  price: number,
  quoteUuid: string
) {
  const mutationInput = {
    orgUuid: organizationUuid,
    orgId: organizationId,
    stripeSourceId: sourceId,
    amount: price,
    quoteUuid,
  } as CreateAndChargeNewOrgCardInput;
  const errorText = `AdminUpgradePlanActions - could not charge card for self serve quote quote=${quoteUuid} org=${organizationUuid}`;


  return RemindAPI.execute<CreateAndChargeNewOrgCard, CreateAndChargeNewOrgCardVariables>({
    mutation: CREATE_AND_CHARGE_NEW_ORG_CARD_MUTATION,
    variables: { input: mutationInput },
  }).then(({ createAndChargeNewOrgCard: resp }) => {
    if (resp.error) {
      console.warn(resp.error.message);
      console.error(errorText);
      return { success: false, errorMessage: resp.error.message };
    } else if (resp.declineReason) {
      console.warn(resp.declineReason);
      console.error(errorText);
      return { success: false, declineReason: resp.declineReason };
    } else {
      return { success: true, declineReason: null, errorMessage: null };
    }
  }).catch((err) => {
    console.warn(err);
    console.error(errorText);
    return { success: false, declineReason: null, errorMessage: err.message };
  });
}
